<div class="issues-ratio-details">
  @if (detailsData(); as data) {
    <div class="details-header">
      <h4 class="details-title">Distribución del tiempo en tareas completadas</h4>
      <div class="details-summary">
        <span class="summary-pill issues">
          {{ data.issues_completed_tasks_count }} issue{{ data.issues_completed_tasks_count === 1 ? '' : 's' }}
        </span>
        <span class="summary-pill non-issues">
          {{ data.non_issues_completed_tasks_count }} restante{{ data.non_issues_completed_tasks_count === 1 ? '' : 's' }}
        </span>
      </div>
    </div>

    <div class="summary-row">
      <div class="summary-chip" matTooltip="Tiempo registrado en issues completadas." matTooltipPosition="above">
        <span class="summary-chip-label">Issues</span>
        <span class="summary-chip-value">{{ data.issues_working_time_in_seconds | SecondsToHourString }}</span>
      </div>
      <div class="summary-chip" matTooltip="Tiempo registrado en tareas/stories completadas." matTooltipPosition="above">
        <span class="summary-chip-label">Otras tareas</span>
        <span class="summary-chip-value">{{ data.non_issues_working_time_in_seconds | SecondsToHourString }}</span>
      </div>
      <div class="summary-chip" matTooltip="Tiempo total registrado en tareas completadas." matTooltipPosition="above">
        <span class="summary-chip-label">Total</span>
        <span class="summary-chip-value">{{ data.total_working_time_in_seconds | SecondsToHourString }}</span>
      </div>
    </div>

    <div class="ratio-bar" [attr.aria-label]="data.tooltip_summary">
      <div class="ratio-bar-segment ratio-bar-segment--issues" [style.width.%]="issuesBarWidth()">
        @if (issuesBarWidth() >= 10) {
          <span class="ratio-bar-label">{{ issuesBarWidth() | number: '1.0-1' }}%</span>
        }
      </div>
      <div class="ratio-bar-segment ratio-bar-segment--non-issues" [style.width.%]="nonIssuesBarWidth()">
        @if (nonIssuesBarWidth() >= 10) {
          <span class="ratio-bar-label">{{ nonIssuesBarWidth() | number: '1.0-1' }}%</span>
        }
      </div>
    </div>

    <div class="ratio-legend">
      <span class="legend-item"><span class="legend-dot legend-dot--issues"></span>Issues</span>
      <span class="legend-item"><span class="legend-dot legend-dot--non-issues"></span>Otras tareas</span>
    </div>
  } @else {
    <p class="no-data">No hay tiempo registrado en tareas completadas en este periodo.</p>
  }
</div>
